<template>
  <v-container fluid grid-list-xl>
    <v-card>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-toolbar-side-icon><v-icon>mdi-console</v-icon></v-toolbar-side-icon>
        <v-toolbar-title>{{$t('app.developer')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="developer">
      API URL: {{ apiUrl }}<hr />
      Access token: Bearer&nbsp;{{ accessToken }}<hr />
      Refresh token: Bearer&nbsp;{{ refreshToken }}<hr />
      <v-switch v-model="this.eruda" @change="toggleEruda()" label="Eruda debugger">
      </v-switch>
      </v-card-text>

    </v-card>

  </v-container>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, { fieldsBagName: 'veeErrors' });

export default {
  data() {
    return {
      apiUrl: window.api_url,
      accessToken: localStorage.getItem('access-token'),
      refreshToken: localStorage.getItem('refresh-token'),
      eruda: localStorage.getItem('active-eruda'),
    };
  },
  mounted() {
  },
  methods: {
    toggleEruda() {
      if (localStorage.getItem('active-eruda')) {
        localStorage.removeItem('active-eruda');
      } else {
        localStorage.setItem('active-eruda', true);
      }
      setTimeout(() => window.location.reload(), 100);
    },
  },
};
</script>
<style scoped>
.developer {
  overflow-wrap: break-word;
  overflow: wrap;
}
</style>
